import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';

export const PrivateRoute = ({ children, isValid, isLoading, setActiveNavPage, activeNavPage }) => {
	useEffect(() => {
		if (isValid && setActiveNavPage) {
			setActiveNavPage(activeNavPage);
		}
	}, [isValid, setActiveNavPage, activeNavPage]);

	// Показываем загрузку пока идет валидация
	if (isLoading) {
		return (
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				backgroundColor: 'var(--tg-theme-bg-color, #ffffff)'
			}}>
				<div className="loader"></div>
			</div>
		);
	}

	if (isValid === false) {
		console.error('Validation failed, redirecting to bot');
		window.location.href = 'https://t.me/EazyPassBot';
		return null;
	}

	return children;
};
